import * as React from 'react';
import { IgcRippleComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * A ripple can be applied to an element to represent
 * interactive surface.
 * @class
 */
export const IgrRipple = /* @__PURE__ */ createComponent({
  tagName: 'igc-ripple',
  displayName: 'IgrRipple',
  elementClass: Component,
  react: React,
});

export type IgrRipple = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrRippleModule = Component;
